import React from 'react';
import { Dumbbell, Users, CheckCircle, } from 'lucide-react';
import StatsCard from '../../dashboard/components/StatsCard';
import { ProgramStats } from '../../../types/program';

interface ProgramStatsCardsProps {
  stats: ProgramStats | null;
  isLoading?: boolean;
}

const ProgramStatsCards: React.FC<ProgramStatsCardsProps> = ({ stats, isLoading }) => {
  return (
    <div className="flex gap-6 flex-wrap">
      <div className="flex-1 min-w-[240px]">
        <StatsCard
          icon={<Dumbbell size={24} />}
          label="Total Programs"
          value={stats?.totalPrograms || 0}
          isLoading={isLoading}
        />
      </div>
      <div className="flex-1 min-w-[240px]">
        <StatsCard
          icon={<Users size={24} />}
          label="Active Enrollments"
          value={stats?.activeEnrollments || 0}
          isLoading={isLoading}
        />
      </div>
      <div className="flex-1 min-w-[240px]">
        <StatsCard
          icon={<CheckCircle size={24} />}
          label="Completion Rate"
          value={`${stats?.completionRate || 0}%`}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default ProgramStatsCards;
